import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import { DialogService } from '../../../../shared/services/dialog.service';
import { ValidationService } from '../../../../shared/services/validation.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PreviousWaitingRoomService } from './previous-waiting-room.service';
import { SelectClinicPopupComponent } from '../../../select-clinic/select-clinic-popup.component';
import { ConsultationHistoryComponent } from '../../../consultation-history/consultation-history.component';
import { TMBDataTableComponent } from '../../../../components/data-table/data-table.component';
import { SharedService } from '../../../../shared/services/share.services';

@Component({
    selector: 'app-previous-waiting-room',
    templateUrl: 'previous-waiting-room.component.html',
    providers: [PreviousWaitingRoomService]
})

export class PreviousWaitingRoomComponent extends TMBDataTableComponent implements OnInit {
    public appConstants = AppConstants;
    public previousWaitingRoomForm: FormGroup;

    constructor(private formBuilder: FormBuilder,
        private router: Router,
        public utility: Utility,
        private previousWaitingRoomService: PreviousWaitingRoomService, public sharedService: SharedService,
        public dialogService: DialogService) {
        super(sharedService);
        this.createForm();

    }

    ngOnInit() {
        this.setPage({ offset: 0 });
    }

    createForm() {
        const currentDate = new Date();
        this.previousWaitingRoomForm = this.formBuilder.group({
            fromDate: [currentDate, [Validators.required]],
            toDate: [currentDate, [Validators.required]]
        });

        this.page.size = 100;
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            fromDate: this.utility.convertDateToISOString(new Date(this.previousWaitingRoomForm.value.fromDate.setHours(0, 0, 0, 0))),
            toDate: this.utility.convertDateToISOString(new Date(this.previousWaitingRoomForm.value.toDate.setHours(23, 59, 59, 999)))
        };

        // this.dataRow = this.previousWaitingRoomService.getPreviousWaitingList(param);
        this.previousWaitingRoomService.getPreviousWaitingList(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.page.totalElements = data['totalRecords'];
                    this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
                    // update dataSource
                    this.dataRow = data['list'];
                }
            }
        );

    }

    /**
     * on filter date click event
     * @param event
     */
    onFilter() {
        if (this.previousWaitingRoomForm.valid) {
            this.setPage({ offset: 0 });
        }
    }

    /**
     * on input from date input event
     * @param event
     */
    onFromDateInput(event) {
        //remove required if the input date is invalid
        ValidationService.removeRequiredError(this.previousWaitingRoomForm.controls['fromDate'], event);

    }

    /**
     * on change from date input event : format the date and set
     * @param event
     */
    onFromDateChange(event) {
        //ValidationService.validationDate(this.previousWaitingRoomForm.controls['fromDate'], event);
        this.previousWaitingRoomService.validateDateRange(this.previousWaitingRoomForm.controls['fromDate'], this.previousWaitingRoomForm.controls['toDate'], true);
    }

    /**
     * on input from date inpput event
     * @param event
     */
    onToDateInput(event) {
        //remove required if the input date is invalid
        ValidationService.removeRequiredError(this.previousWaitingRoomForm.controls['toDate'], event);
    }

    /**
     * on change from date input event : format the date and set
     * @param event
     */
    onToDateChange(event) {
        //ValidationService.validationDate(this.previousWaitingRoomForm.controls['toDate'], event);
        this.previousWaitingRoomService.validateDateRange(this.previousWaitingRoomForm.controls['fromDate'], this.previousWaitingRoomForm.controls['toDate'], false);
    }


    /**
     * open consultation history of a patient
     * @param string id : patient ID
     */
    onOpenConsultationHistory(row) {
        const height = window.screen.height - (window.screen.height * 30 / 100);
        const width = window.screen.width - (window.screen.width * 20 / 100);
        const data = {
            patientId: row.userId,
            id: row.id,
            height: height,
            width: width
        };
        this.dialogService.openComponentDialog(ConsultationHistoryComponent, data, {
            width: '80%',
            height: '810px'
        });
    }

    /**
     * add patient back to waiting room
     * @param string id : patient ID
     */
    onReturnWaitingRoom(id) {
        let dialogRef = this.dialogService.openComponentDialog(SelectClinicPopupComponent).subscribe(result => {
            //user select clinic  result = clinicId
            if (result.isSuccess) {
                const clinicId = result.id;
                this.previousWaitingRoomService.addPatientToWaitingRoom(id, clinicId).subscribe(
                    (addResult) => {
                        if (addResult) {
                          // redirect to waiting room
                          this.router.navigate(['/consultation/waiting-room']);
                          this.dialogService.openSuccessDialog({ message: AppMessages.waitingRoom.addPatientSuccess });
                        }

                    }
                );
            }

        });
    }

}







// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/previous-waiting-room/previous-waiting-room.component.ts